/* =============================================================
   SS — Utils
   Helpers partagés. Chargé une fois dans theme.liquid.
   Namespace unique : window.SS
   ============================================================= */

(function () {
  if (window.SS) return;

  const SS = {};

    /* -----------------------------------------------------------
     1. Environnement
     Source : window.SS_CONFIG (theme.liquid), fallback window.Shopify
     ----------------------------------------------------------- */
    const CFG = window.SS_CONFIG || {};
    const SHOPIFY_ROUTES = (window.Shopify && window.Shopify.routes) || {};
    const CFG_ROUTES = CFG.routes || {};

    SS.config = CFG;
    SS.bp = { mobile: 750, desktop: 981, large: 1200 };

    // Routes normalisées en camelCase, avec fallback en cascade
    SS.routes = {
        root:              CFG_ROUTES.root              || SHOPIFY_ROUTES.root_url              || '/',
        cart:              CFG_ROUTES.cart              || SHOPIFY_ROUTES.cart_url              || '/cart',
        cartAdd:           CFG_ROUTES.cartAdd           || SHOPIFY_ROUTES.cart_add_url          || '/cart/add',
        cartChange:        CFG_ROUTES.cartChange        || SHOPIFY_ROUTES.cart_change_url       || '/cart/change',
        cartUpdate:        CFG_ROUTES.cartUpdate        || SHOPIFY_ROUTES.cart_update_url       || '/cart/update',
        cartClear:         CFG_ROUTES.cartClear         || SHOPIFY_ROUTES.cart_clear_url        || '/cart/clear',
        predictiveSearch:  CFG_ROUTES.predictiveSearch  || SHOPIFY_ROUTES.predictive_search_url || '/search/suggest'
    };

    SS.isEditor    = () => CFG.designMode === true || (window.Shopify && window.Shopify.designMode === true);
    SS.isMobile    = () => window.innerWidth < SS.bp.mobile;
    SS.isDesktop   = () => window.innerWidth >= SS.bp.desktop;
    SS.reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    SS.template = CFG.template || '';
    SS.locale   = CFG.locale || document.documentElement.lang || 'fr';
    SS.t        = (key) => (CFG.strings || {})[key] || '';

  /* -----------------------------------------------------------
     2. Timing
     ----------------------------------------------------------- */
  SS.debounce = (fn, wait = 200) => {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  SS.throttle = (fn, limit = 100) => {
    let ready = true;
    return function (...args) {
      if (!ready) return;
      ready = false;
      fn.apply(this, args);
      setTimeout(() => { ready = true; }, limit);
    };
  };

  // Throttle callé sur le refresh rate — pour scroll / resize / parallax
  SS.rafThrottle = (fn) => {
    let ticking = false;
    return function (...args) {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        fn.apply(this, args);
        ticking = false;
      });
    };
  };

  /* -----------------------------------------------------------
     3. Breakpoints réactifs
     Exécute enter() en entrant dans le MQ, leave() en sortant.
     Retourne une fonction de cleanup (à appeler en disconnectedCallback).
     ----------------------------------------------------------- */
  SS.onBreakpoint = (query, enter, leave) => {
    const mq = window.matchMedia(query);
    const handler = (e) => (e.matches ? enter && enter() : leave && leave());
    handler(mq);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  };

  /* -----------------------------------------------------------
     4. Chargement à la demande (Swiper, GSAP, etc.)
     Ne charge qu'une fois, même si appelé par 10 sections.
     ----------------------------------------------------------- */
  const _loaded = {};

  SS.loadScript = (src) => {
    if (_loaded[src]) return _loaded[src];
    _loaded[src] = new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = src;
      el.onload = resolve;
      el.onerror = () => reject(new Error('SS: échec du chargement ' + src));
      document.head.appendChild(el);
    });
    return _loaded[src];
  };

  SS.loadStyle = (href) => {
    if (_loaded[href]) return _loaded[href];
    _loaded[href] = new Promise((resolve) => {
      const el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = href;
      el.onload = resolve;
      document.head.appendChild(el);
    });
    return _loaded[href];
  };

  // Raccourci Swiper 11
  SS.loadSwiper = () => Promise.all([
    SS.loadScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'),
    SS.loadStyle('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css')
  ]);

  /* -----------------------------------------------------------
     5. Formatage
     ----------------------------------------------------------- */
  // Reproduit le format de la boutique (money_format de Shopify)
  SS.formatMoney = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
        const fmt = format || CFG.moneyFormat || window.SS_MONEY_FORMAT || '{{amount}}';

    const number = (value, precision, decimal, thousands) => {
      value = (value / 100.0).toFixed(precision);
      const parts = value.split('.');
      const int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const dec = parts[1] ? decimal + parts[1] : '';
      return int + dec;
    };

    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount';
    let value = '';

    switch (key) {
      case 'amount':                   value = number(cents, 2, '.', ','); break;
      case 'amount_no_decimals':       value = number(cents, 0, '.', ','); break;
      case 'amount_with_comma_separator':     value = number(cents, 2, ',', ' '); break;
      case 'amount_no_decimals_with_comma_separator': value = number(cents, 0, ',', ' '); break;
      case 'amount_with_space_separator':     value = number(cents, 2, ',', ' '); break;
      case 'amount_no_decimals_with_space_separator': value = number(cents, 0, ',', ' '); break;
      default:                         value = number(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  SS.escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));

  SS.handleize = (str) => String(str)
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  /* -----------------------------------------------------------
     6. Requêtes
     ----------------------------------------------------------- */
  SS.fetchJSON = async (url, options = {}) => {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...options
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.description || res.statusText), { data, status: res.status });
    return data;
  };

      /* -----------------------------------------------------------
       7. Panier
       Dispatch 'cart:update' sur document + rafraîchit le DOM
       rendu par Liquid (icône, pastille, tiroir) via les sections.
       ----------------------------------------------------------- */

    /* Sections dont on veut le HTML à jour après une mutation */
    const cartSectionIds = () => {
      const ids = new Set();
      document
        .querySelectorAll('#header-group .shopify-section[id^="shopify-section-"]')
        .forEach((el) => ids.add(el.id.replace('shopify-section-', '')));
      return Array.from(ids);
    };

    /* Remplace chirurgicalement les morceaux rendus par Liquid */
    const applyCartSections = (sections) => {
      if (!sections) return;

      Object.values(sections).forEach((html) => {
        if (typeof html !== 'string' || html === '') return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Icône : contenu + classes, sans remplacer l'élément
        const nextIcons = doc.querySelectorAll('cart-icon');
        document.querySelectorAll('cart-icon').forEach((icon, i) => {
          const next = nextIcons[i];
          if (!next) return;
          icon.className = next.className;
          icon.innerHTML = next.innerHTML;
        });

        // Contenu du tiroir
        const nextInner = doc.querySelector('.cart-drawer__inner');
        const inner = document.querySelector('.cart-drawer__inner');
        if (nextInner && inner) inner.innerHTML = nextInner.innerHTML;

        // Classe « panier vide »
        const nextDialog = doc.querySelector('.cart-drawer__dialog');
        const dialog = document.querySelector('.cart-drawer__dialog');
        if (nextDialog && dialog) {
          dialog.classList.toggle(
            'cart-drawer--empty',
            nextDialog.classList.contains('cart-drawer--empty')
          );
        }
      });
    };

    /* Mutation générique : POST + rafraîchissement + notification */
    const cartMutate = async (url, body, opts = {}) => {
      const payload = Object.assign({}, body, {
        sections: opts.sections || cartSectionIds(),
        sections_url: window.location.pathname
      });

      const data = await SS.fetchJSON(url + '.js', {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      applyCartSections(data.sections);
      return data;
    };

    SS.cart = {
      sectionIds: cartSectionIds,
      applySections: applyCartSections,

      get: () => SS.fetchJSON(SS.routes.cart + '.js'),

      add: async (items, opts = {}) => {
        const body = Array.isArray(items) ? { items } : { items: [items] };
        const data = await cartMutate(SS.routes.cartAdd, body, opts);
        const cart = await SS.cart.get();
        SS.cart.notify(cart, data);
        return data;
      },

      change: async (body, opts = {}) => {
        const cart = await cartMutate(SS.routes.cartChange, body, opts);
        SS.cart.notify(cart);
        return cart;
      },

      update: async (updates, opts = {}) => {
        const cart = await cartMutate(SS.routes.cartUpdate, { updates }, opts);
        SS.cart.notify(cart);
        return cart;
      },

      clear: async (opts = {}) => {
        const cart = await cartMutate(SS.routes.cartClear, {}, opts);
        SS.cart.notify(cart);
        return cart;
      },

      notify: (cart, added) => {
        document.dispatchEvent(new CustomEvent('ss:cart:update', {
          bubbles: true,
          detail: { cart, added }
        }));
      },

      /* Attend que le composant soit défini : cart-drawer.js est chargé
         en module fetchpriority=low, .open() peut ne pas exister au 1er clic */
      openDrawer: async () => {
        const drawer = document.querySelector('cart-drawer-component');
        if (!drawer) return;
        await customElements.whenDefined('cart-drawer-component');
        if (typeof drawer.open === 'function') drawer.open();
      }
    };

  /* -----------------------------------------------------------
     8. Section Rendering API
     Récupère le HTML à jour d'une section (filtres, panier, pagination).
     ----------------------------------------------------------- */
  SS.fetchSection = async (sectionId, url) => {
    const target = new URL(url || window.location.href, window.location.origin);
    target.searchParams.set('section_id', sectionId);
    const res = await fetch(target.toString());
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  };

  /* -----------------------------------------------------------
     9. Scroll lock (modales, drawers, menus)
     Compteur : supporte plusieurs verrous imbriqués.
     ----------------------------------------------------------- */
  let _locks = 0;

  SS.lockScroll = () => {
    if (_locks++ > 0) return;
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--ss-scrollbar-width', sbw + 'px');
    document.documentElement.classList.add('ss-scroll-locked');
  };

  SS.unlockScroll = () => {
    if (_locks === 0) return;
    if (--_locks > 0) return;
    document.documentElement.classList.remove('ss-scroll-locked');
  };

  /* -----------------------------------------------------------
     10. Accessibilité
     ----------------------------------------------------------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), details, summary';

  // Retourne une fonction de cleanup
  SS.trapFocus = (container, initialEl) => {
    const els = Array.from(container.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
    const first = els[0];
    const last = els[els.length - 1];

    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    document.addEventListener('keydown', onKey);
    (initialEl || first)?.focus();
    return () => document.removeEventListener('keydown', onKey);
  };

  SS.onEscape = (fn) => {
    const handler = (e) => { if (e.key === 'Escape') fn(e); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  };

  SS.onClickOutside = (el, fn) => {
    const handler = (e) => { if (!el.contains(e.target)) fn(e); };
    // setTimeout : évite que le clic d'ouverture déclenche la fermeture
    setTimeout(() => document.addEventListener('click', handler), 0);
    return () => document.removeEventListener('click', handler);
  };

  /* -----------------------------------------------------------
     11. DOM
     ----------------------------------------------------------- */
  SS.$  = (sel, ctx = document) => ctx.querySelector(sel);
  SS.$$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  // Attend qu'un élément soit visible avant d'exécuter (lazy init lourde)
  SS.onVisible = (el, fn, options = {}) => {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        fn(entry.target);
      });
    }, { rootMargin: '200px', threshold: 0, ...options });
    io.observe(el);
    return () => io.disconnect();
  };

  SS.scrollTo = (target, offset = 0) => {
    const el = typeof target === 'string' ? SS.$(target) : target;
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: SS.reduceMotion() ? 'auto' : 'smooth' });
  };

  /* -----------------------------------------------------------
     12. Bus d'événements interne
     Pour la communication entre sections sans couplage.
     ----------------------------------------------------------- */
  SS.on   = (name, fn) => document.addEventListener('ss:' + name, fn);
  SS.off  = (name, fn) => document.removeEventListener('ss:' + name, fn);
  SS.emit = (name, detail) => document.dispatchEvent(new CustomEvent('ss:' + name, { bubbles: true, detail }));

  /* -----------------------------------------------------------
     13. Hauteur viewport mobile (--ss-vh)
     Corrige le 100vh sur iOS Safari.
     ----------------------------------------------------------- */
  const setVh = () => {
    document.documentElement.style.setProperty('--ss-vh', window.innerHeight * 0.01 + 'px');
  };
  setVh();
  window.addEventListener('resize', SS.debounce(setVh, 150));

  window.SS = SS;

  /* 14. Sélecteurs de localisation — soumission au changement */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-ss-locale-select]');
    if (!select) return;
    select.form?.submit();
  });
  
})();
